<template>
  <TransitionRoot as="template" :show="openDrawers.length > 0">
    <div class="relative z-40">
      <TransitionChild
        as="template"
        enter="ease-in-out duration-500"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in-out duration-500"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div class="fixed inset-0 bg-neutral-950/70 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 overflow-hidden">
        <div
          class="absolute inset-0 overflow-hidden"
          @click="Drawer.closeAll()"
        >
          <div class="fixed inset-y-0 right-0 flex max-w-full pl-10">
            <TransitionChild
              as="template"
              enter="transform transition ease-in-out duration-500 sm:duration-700"
              enter-from="translate-x-full"
              enter-to="translate-x-0"
              leave="transform transition ease-in-out duration-500 sm:duration-700"
              leave-from="translate-x-0"
              leave-to="translate-x-full"
            >
              <div @click.stop>
                <template v-for="(drawer, index) of openDrawers" :key="index">
                  <DrawerProvider :drawer="drawer">
                    <component :is="drawer.vnode" />
                  </DrawerProvider>
                </template>
              </div>
            </TransitionChild>
          </div>
        </div>
      </div>
    </div>
  </TransitionRoot>
</template>
<script setup lang="ts">
import { TransitionChild, TransitionRoot } from '@headlessui/vue';
import { computed } from 'vue';
import { Drawer } from './drawer';
import DrawerProvider from './DrawerProvider.vue';

const openDrawers = computed(() => {
  const drawers: Drawer[] = Array.from(Drawer.drawers.value.values());
  return drawers;
});
</script>
